module.exports = __webpack_public_path__ + "img/122.9.90419a4a.png";